document.addEventListener("DOMContentLoaded", function () {
    const openBtn = document.getElementById("openStoreDrawer");
    const drawer = document.getElementById("storeDrawer");

    if (!openBtn || !drawer) {
        console.log("Drawer or opener not found.");
        return;
    }

    const overlay = drawer.querySelector(".store-drawer__overlay");
    const closeBtn = drawer.querySelector(".store-drawer__close");

    openBtn.addEventListener("click", function () {
        drawer.classList.add("active");
        document.body.style.overflow = "hidden";
    });

    function closeDrawer() {
        drawer.classList.remove("active");
        document.body.style.overflow = "";
    }

    if (closeBtn) {
        closeBtn.addEventListener("click", closeDrawer);
    }

    if (overlay) {
        overlay.addEventListener("click", closeDrawer);
    }
}); 